export default "__VITE_ASSET__DiXoxoXj__"